import React, { useEffect, useState } from "react";
import { Field } from "redux-form";
import { renderTextField, renderTextFieldPreValue } from "../../formcomponents";
import { Table, Button, Grid } from "semantic-ui-react";
import { BaseImgUploadUrl } from "../../formcomponents/Constants";
import ImageUploadField from "./ImageUploadField";
const FileUpladArr = ({
  fields,
  fileList,
  meta: { touched, error, submitFailed },
}) => {
  useEffect(() => {
    fields.push();
  }, []);

  return (
    <div>
      {fields.map((item, index) => (
        <div key={index}>
          <Grid.Row>
            <Grid columns="three">
              <Grid.Row>
                <Grid.Column>
                  <div
                    style={{
                      marginTop: "25px",
                    }}
                  >
                    <Field
                      name={`${item}`}
                      label="File"
                      component={ImageUploadField}
                    />
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name={`${item}.fileTypeName`}
                    label="File Name"
                    component={renderTextField}
                  />
                </Grid.Column>
                <Grid.Column>
                  <br />
                  {index != 0 && (
                    <Button
                      type="button"
                      floated="left"
                      negative
                      onClick={() => fields.remove(index)}
                    >
                      X
                    </Button>
                  )}

                  {fields.length - 1 === index && (
                    <Button
                      type="button"
                      positive
                      floated="left"
                      onClick={() => fields.push({})}
                    >
                      Add More
                    </Button>
                  )}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Row>
        </div>
      ))}
      <br />
    </div>
  );
};

export default FileUpladArr;
